module.exports = __webpack_public_path__ + "static/media/Inter-BoldItalic.3b22d006.woff";